import React from "react";

const PILL: Record<string, string> = {
  ongoing: "bg-[#cfe0ff] text-[#0b1220]",
  active: "bg-[#cfe0ff] text-[#0b1220]",
  completed: "bg-emerald-200 text-emerald-900",
  cancelled: "bg-rose-200 text-rose-900",
  issue: "bg-amber-200 text-amber-900",
};

export default function TripTable({
  list,
  highlightId,
  onSelect
}: {
  list: [string, any][];
  highlightId?: string;
  onSelect?: (id?: string) => void;
}) {
  return (
    <div className="px-3 overflow-auto">
      <table className="w-full text-left border-separate border-spacing-0 rounded-xl overflow-hidden">
        <thead className="bg-[#93bafd] text-[#0b1220]">
          <tr className="[&>th]:font-semibold [&>th]:text-[13px] [&>th]:py-2.5 [&>th]:px-3 [&>th]:border-b [&>th]:border-[#93bafd]">
            <th className="w-[16%]">Trip ID</th>
            <th className="w-[12%]">Vehicle</th>
            <th className="w-[10%]">Status</th>
            <th className="w-[14%]">Progress</th>
            <th className="w-[12%]">Distance</th>
            <th className="w-[12%]">Total</th>
            <th className="w-[10%]">Speed</th>
            <th className="w-[7%]">Battery</th>
            <th className="w-[7%]">Fuel</th>
          </tr>
        </thead>

        <tbody className="bg-[#bfd4fe] text-[#0b1220] [&>tr>td]:py-3 [&>tr>td]:px-3 [&>tr>td]:text-[13px]">
          {list.map(([id, t]) => {
            const status = (t.status || "ongoing").toLowerCase();
            const isHit = highlightId && id === highlightId;

            const pct = Math.max(0, Math.min(100, Math.round(t.progress ?? 0)));
            const distance =
              typeof t.distanceKm === "number"
                ? `${t.distanceKm.toFixed(1)} km`
                : "—";
            const totalDistance =
              typeof t.totalDistanceKm === "number"
                ? `${t.totalDistanceKm.toFixed(1)} km`
                : "—";
            const speed =
              typeof t.speedKph === "number" ? `${t.speedKph} km/h` : "—";
            const battery =
              typeof t.batteryPct === "number" ? `${t.batteryPct}%` : "—";
            const fuel =
              typeof t.fuel === "number" ? `${Math.round(t.fuel)}%` : "—";
            return (
              // <tr
              //   key={id}
              //   className={`border-t border-[#93bafd] transition ${
              //     isHit ? "bg-white/80" : "hover:bg-white/40"
              //   }`}
              // >
              <tr
  key={id}
  onClick={() => onSelect?.(id)}
  className={`border-t border-[#93bafd] transition cursor-pointer select-none ${
    isHit ? "bg-white/80 ring-2 ring-blue-500/60" : "hover:bg-white/40"
  }`}
>

                <td className="font-mono text-[12px] text-slate-800 break-words max-w-[12rem]">
                  {id}
                </td>
                <td className="font-medium">{t.vehicleId ?? "—"}</td>

                <td>
                  <span
                    className={`px-3 py-1 rounded-full text-[12px] font-semibold inline-flex ${
                      PILL[status] || "bg-slate-200 text-slate-900"
                    }`}
                  >
                    {status.toUpperCase()}
                  </span>
                </td>

                <td>
                  <div className="w-full">
                    <div className="h-2 bg-white/70 rounded-full overflow-hidden">
                      <div
                        className={`${
                          pct >= 100 ? "bg-emerald-400" : "bg-[#3b6ef6]"
                        } h-full`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <div className="text-xs text-slate-700 mt-1">{pct}%</div>
                  </div>
                </td>

                <td>{distance}</td>
                <td>{totalDistance}</td>

                <td className="text-slate-900">{speed}</td>
                <td className="text-emerald-700">{battery}</td>
                <td className="text-emerald-700">{fuel}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
